import { create } from 'zustand';

interface MenuState {
  openSubmenu: string | null;
  setOpenSubmenu: (submenu: string | null) => void;
  toggleSubmenu: (title: string) => void;
  expandSubmenu: (title: string) => void;
  collapseAllSubmenus: () => void;
}

export const useMenuState = create<MenuState>(set => ({
  openSubmenu: null,
  setOpenSubmenu: submenu => set({ openSubmenu: submenu }),
  toggleSubmenu: title =>
    set(state => ({ openSubmenu: state.openSubmenu === title ? null : title })),
  expandSubmenu: title => set({ openSubmenu: title }),
  collapseAllSubmenus: () => set({ openSubmenu: null })
}));
